import { PayloadAction } from "@reduxjs/toolkit";
import { ClusterState } from "@/components/PageCluster/redux/types";
import { ClusterApiResponse } from "@/components/PageCluster/api/interface";

const clusterReducer = {
  setClusterData: (state: ClusterState, action: PayloadAction<ClusterApiResponse>) => {
    state.clusterData = action.payload;
  },
  setLoading: (state: ClusterState, action: PayloadAction<boolean>) => {
    state.loading = action.payload;
  },
  setDevice: (state: ClusterState, action: PayloadAction<any>) => {
    state.ua = action.payload;
  },
  setError: (state: ClusterState, action: PayloadAction<any>) => {
    state.error = action.payload;
  },
  setClusterSlug: (state: ClusterState, action: PayloadAction<string>) => {
    state.clusterSlug = action?.payload;
  },
};

export default clusterReducer;
